import _classCallCheck from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { SignalOperator } from "./SignalOperator";
import { WaveShaper } from "./WaveShaper";
/**
 * AudioToGain converts an input in AudioRange [-1,1] to NormalRange [0,1].
 * See [[GainToAudio]].
 * @category Signal
 */

export var AudioToGain = /*#__PURE__*/function (_SignalOperator) {
  _inherits(AudioToGain, _SignalOperator);

  var _super = _createSuper(AudioToGain);

  function AudioToGain() {
    var _this;

    _classCallCheck(this, AudioToGain);

    _this = _super.apply(this, arguments);
    _this.name = "AudioToGain";
    /**
     * The node which converts the audio ranges
     */

    _this._norm = new WaveShaper({
      context: _this.context,
      mapping: function mapping(x) {
        return (x + 1) / 2;
      }
    });
    /**
     * The AudioRange input [-1, 1]
     */

    _this.input = _this._norm;
    /**
     * The GainRange output [0, 1]
     */

    _this.output = _this._norm;
    return _this;
  }
  /**
   * clean up
   */


  _createClass(AudioToGain, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(AudioToGain.prototype), "dispose", this).call(this);

      this._norm.dispose();

      return this;
    }
  }]);

  return AudioToGain;
}(SignalOperator);